import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Accessibility = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="accessibility icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C13.65 0 15 1.35 15 3C15 4.65 13.65 6 12 6C10.35 6 8.99999 4.65 8.99999 3C8.99999 1.35 10.35 0 12 0ZM20.5 10C21.3284 10 22 9.32843 22 8.5C22 7.67157 21.3284 7 20.5 7H3.5C2.67157 7 2 7.67157 2 8.5C2 9.32843 2.67157 10 3.5 10H7.99999V22.5C7.99999 23.3284 8.67156 24 9.49999 24C10.3284 24 11 23.3284 11 22.5V17H13V22.5C13 23.3284 13.6716 24 14.5 24C15.3284 24 16 23.3284 16 22.5V10H20.5Z"
    />
  </svg>
)
